import { getAdvanced } from '../../utils'
import { getImageQuality } from '../../utils'
const configAggregator = (node, props) => {
    let dataProductSkuAttribute = 'data-pb-product-sku'
    let forms = node.querySelectorAll(`[${dataProductSkuAttribute}]`)

    if (forms.length === 0) {
        dataProductSkuAttribute = 'data-product-sku'
        forms = node.querySelectorAll(`[${dataProductSkuAttribute}]`)
    }

    let carouselConfig = {}

    if (props.appearance === 'carousel') {
        carouselConfig = {
            autoplay: node.getAttribute('data-autoplay') === 'true',
            autoplaySpeed: parseInt(node.getAttribute('data-autoplay-speed')),
            infinite: node.getAttribute('data-infinite-loop') === 'true',
            arrows: node.getAttribute('data-show-arrows') === 'true',
            dots: node.getAttribute('data-show-dots') === 'true',
            carouselMode: node.getAttribute('data-carousel-mode'),
            centerPadding: node.getAttribute('data-center-padding'),
            additionalConfig: node.getAttribute('data-additional-config'),
            brandTheme: node.getAttribute('data-brand-theme'),
            customBannerUrl: node.getAttribute('data-custom-banner-url'),
            imageSrc: node.getAttribute('src'),
            bannerPosition: node.getAttribute('data-custom-banner-position')
        }
    }

    if (props.appearance === 'carousel_image') {
        carouselConfig = {
            autoplay: node.getAttribute('data-autoplay') === 'true',
            autoplaySpeed: parseInt(node.getAttribute('data-autoplay-speed')),
            infinite: node.getAttribute('data-infinite-loop') === 'true',
            arrows: node.getAttribute('data-show-arrows') === 'true',
            dots: node.getAttribute('data-show-dots') === 'true',
            carouselMode: node.getAttribute('data-carousel-mode'),
            centerPadding: node.getAttribute('data-center-padding'),
            additionalConfig: node.getAttribute('data-additional-config'),
            brandHeading: node.getAttribute('data-brand-heading'),
            brandBg: node.getAttribute('data-brand-bg'),
            brandBgMobile: node.getAttribute('data-brand-bg-mobile'),
            brandContent: node.getAttribute('data-brand-content'),
            brandButtonText: node.getAttribute('data-brand-button-text'),
            brandButtonLink: node.getAttribute('data-brand-button-link'),
            brandLogo: node.getAttribute('data-brand-logo'),
            imageQuality: getImageQuality([]),
            isProductGridEnabledOnDesktop: node.getAttribute(
                'data-product-grid-desktop'
            ),
            isProductGridEnabledOnMobile: node.getAttribute(
                'data-product-grid-mobile'
            )
        }
    }

    return {
        skus: [...forms].map((form) =>
            form.getAttribute(dataProductSkuAttribute)
        ),
        ...carouselConfig,
        ...getAdvanced(node)
    }
}

export default configAggregator
